export default __webpack_public_path__ + "static/media/teacher.5db39c74.jpg";